import { Modal } from '@bfe/moly';
import { LOCALES, setLocale } from '@web3/utils';
import clsx from 'clsx';
import { useLocale } from '../../../store/i18nMessage';

export type LocaleSelectorProps = {
  changeRote?: boolean;
  // 切换语言是否需要刷新页面
  refreshWhenChangeLocale?: boolean;
};

export function LocaleSelector({ changeRote = true, refreshWhenChangeLocale = false }: LocaleSelectorProps) {
  const { t, locale, setLocale: setLang, modalVisible, showModal, hideModal } = useLocale();

  const handleSelectLang = (locale: string) => {
    if (changeRote) {
      setLocale(locale, refreshWhenChangeLocale);
    } else {
      setLang(locale);
    }
    hideModal();
  };
  return (
    <>
      <div className="nav-link !w-12 items-center flex hover:bg-[rgba(255, 255, 255, 0.06)]" onClick={showModal}>
        <div className="size-6 svg-full ">{localeIcon}</div>
      </div>
      <Modal modal={false} width={800} title={t('lang_chose')} open={modalVisible} footer={null} closable onCancel={hideModal}>
        <ul className=" whitespace-pre-wrap pb-6 min-h-[346px]">
          {LOCALES.map((item) => {
            return (
              <li
                key={item.value}
                className={clsx(' inline-block w-1/3 mb-[10px] p-[10px] cursor-pointer text-base hover:text-bds-brand-700-normal', {
                  'text-bds-brand-600-hover': locale === item.value,
                })}
                onClick={() => handleSelectLang(item.value)}
              >
                {item.label}
              </li>
            );
          })}
        </ul>
      </Modal>
    </>
  );
}

const localeIcon = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path d="M2.667 16c0-7.364 5.97-13.333 13.333-13.333s13.333 5.97 13.333 13.333c0 7.364-5.97 13.333-13.333 13.333s-13.333-5.97-13.333-13.333zM12.692 5.856c-3.865 1.259-6.76 4.666-7.276 8.811h3.996c0.304-3.151 1.438-6.169 3.281-8.811zM19.308 5.856c1.843 2.641 2.977 5.66 3.281 8.811h3.996c-0.517-4.145-3.412-7.551-7.276-8.811zM19.907 14.667c-0.359-3.164-1.707-6.189-3.907-8.721-2.201 2.532-3.548 5.557-3.907 8.721h7.815zM12.093 17.333c0.359 3.164 1.707 6.189 3.907 8.721 2.201-2.532 3.548-5.557 3.907-8.721h-7.815zM9.411 17.333h-3.996c0.517 4.145 3.412 7.551 7.276 8.811-1.843-2.641-2.977-5.66-3.281-8.811zM19.308 26.144c3.865-1.259 6.76-4.666 7.277-8.811h-3.996c-0.304 3.151-1.438 6.169-3.281 8.811z"></path>
  </svg>
);
